export default "__VITE_ASSET__qEVmaEs8__"